
















































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

type RowItem = { label: string; options: string[]; suffix?: string };
type SectionItem = { title: string; showHeader: boolean; rows: RowItem[] };

@Component
export default class ReportZhuanbing extends Vue {
  @Prop() private detail: any;
  @Prop() private ifEdit: any;
  private data: any = {};

  private scaleQuestionMap: Record<string, string> = {
    kesu: "您是否有咳嗽？",
    shenpi: "您是否有神疲乏力？",
    nadai: "您是否有纳呆？",
    weihan: "您是否有畏寒肢冷？",
    yaoxi: "您是否有腰膝酸软？",
    wugengxiexie: "您是否有五更泄泻？",
    shiyubuzhen: "您是否有食欲不振？",
    xiaobian: "您是否有小便频数？",
    outu: "您是否有呕吐？",
    kaposhi: "您是否有卡波氏肉瘤？",
    linbajie: "您是否有淋巴结肿大？",
  };

  private scaleAnswerMap: Record<number, string> = {
    0: "没有",
    2: "很少",
    4: "有时",
    6: "经常",
  };

  private zhenghouSections: SectionItem[] = [
    { title: "一、舌象、脉象（医师填写）", showHeader: false, rows: [
      { label: "舌色", options: ["淡红", "淡白", "舌红", "舌紫", "舌黯", "其他"] },
      { label: "舌形", options: ["舌体胖大", "舌有齿痕", "舌有裂纹", "舌有瘀斑", "舌下脉络青紫", "舌体瘦薄"] },
      { label: "苔色", options: ["苔白", "苔黄", "苔灰黑"] },
      { label: "苔质", options: ["苔薄", "苔厚", "苔腻", "苔滑", "苔少", "无苔"] },
      { label: "脉象", options: ["沉脉", "细脉", "弱脉", "数脉", "弦脉", "滑脉", "濡脉", "涩脉", "其他"] },
    ] },
    { title: "二、全身情况", showHeader: true, rows: [
      { label: "畏寒怕冷", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "手足发冷", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "自汗（白天不活动出汗）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "盗汗（夜间睡着出汗）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "五心烦热", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "神疲乏力", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "倦怠乏力", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "气短懒言", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "健忘", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "失眠", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "多梦", options: ["无(0)", "有(1)"] },
      { label: "烦躁/焦虑/抑郁", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
    ] },
    { title: "三、头面五官", showHeader: true, rows: [
      { label: "头晕", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "头重如裹", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "面色萎黄", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "面色晦暗", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "目干涩/视物不清", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "耳鸣", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "听力下降", options: ["无(0)", "有(1)"] },
      { label: "口唇色淡", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "口唇紫暗", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "口唇干裂", options: ["无(0)", "有(1)"] },
      { label: "口苦", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "口臭", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "口腻", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "口干咽燥", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "口渴欲饮", options: ["无", "轻", "中", "重", "喜热饮", "喜冷饮"] },
    ] },
    { title: "四、胸腹部", showHeader: true, rows: [
      { label: "纳差（食欲减退）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "消谷善饥", options: ["无(0)", "有(1)"] },
      { label: "胃脘痞胀/腹胀", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "腹部坠胀感", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "嗳气/呃逆", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "恶心/厌油", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "胁痛/胁胀", options: ["无(0)", "轻(1)", "中(2)", "重(3)"], suffix: "性质：□隐痛 □胀痛 □刺痛" },
      { label: "腹痛", options: ["无(0)", "轻(1)", "中(2)", "重(3)"], suffix: "部位：□胃脘 □脐周 □小腹" },
    ] },
    { title: "五、腰背及生殖", showHeader: true, rows: [
      { label: "腰膝酸软", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "腰痛（冷痛/酸痛）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "夜尿频多（≥2次/晚）", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "性欲减退/阳痿", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "女性：月经异常/带下", options: ["无", "有（具体：________）"] },
    ] },
    { title: "六、肢体与皮肤", showHeader: true, rows: [
      { label: "肢体困重", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "肢体麻木", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "爪甲不荣", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "皮肤瘙痒", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "皮肤斑丘疹", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "皮肤瘀点/瘀斑", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "蜘蛛痣/肝掌", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
    ] },
    { title: "七、二便", showHeader: true, rows: [
      { label: "大便稀溏/泄泻", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "大便黏腻不爽", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "大便干结", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "小便色黄", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
      { label: "小便不畅/余沥", options: ["无(0)", "轻(1)", "中(2)", "重(3)"] },
    ] },
  ];

  private zhenghouBleedOptions = ["无", "鼻衄", "齿衄", "皮下瘀斑", "其他________"];
  private zhenghouDiagnosisOptions = ["脾肾阳虚证", "气阴两虚证", "湿热内蕴证", "瘀血阻络证", "肺脾气虚证", "复合证型（请注明：____________）"];

  @Watch("detail", { immediate: true })
  private onDetailChange() { this.data = JSON.parse(JSON.stringify(this.detail || {})); }

  private get zhuanbingRoot() { return (this.data.report && this.data.report.zhuanbing) || {}; }
  private get titleText() { return `${(this.data.template && this.data.template.name) || "专病"}报告`; }
  private get diseaseName() { return this.zhuanbingRoot.diseaseName || ""; }
  private get updatedAt() { return this.zhuanbingRoot.updatedAt || ""; }
  private get scaleData() { return (this.zhuanbingRoot.modules && this.zhuanbingRoot.modules.scale) || null; }
  private get bianzhengData() { return (this.zhuanbingRoot.modules && this.zhuanbingRoot.modules.bianzheng) || null; }
  private get zhenghouData() { return (this.zhuanbingRoot.modules && this.zhuanbingRoot.modules.zhenghou) || null; }

  private get scaleQaList() {
    if (!this.scaleData || !this.scaleData.answers) return [];
    return Object.keys(this.scaleQuestionMap).map((id) => {
      const score = typeof this.scaleData.answers[id] === "number" ? this.scaleData.answers[id] : null;
      return { id, title: this.scaleQuestionMap[id], answer: score === null ? "未作答" : this.scaleAnswerMap[score] || `${score}` };
    }).filter((item) => item.answer !== "未作答");
  }

  private get bianzhengShemianmai() {
    const src = (this.bianzhengData && this.bianzhengData.shemianmai) || {};
    return {
      she: this.getSizhenConclusion(src.she),
      shexia: this.getSizhenConclusion(src.shexia),
      mian: this.getSizhenConclusion(src.mian),
      mai: this.getSizhenConclusion(src.mai),
    };
  }

  private get bianzhengResultText() {
    if (!this.bianzhengData) return "/";
    if (this.bianzhengData.syndromeResultType === "其它") return this.bianzhengData.syndromeResultOtherText || "其它";
    return this.bianzhengData.syndromeResultType || "/";
  }
  private get bianzhengFormulaText() {
    if (!this.bianzhengData) return "/";
    if (this.bianzhengData.recommendedFormula) return this.bianzhengData.recommendedFormula;
    const result = this.bianzhengResultText;
    if (result === "脾肾阳虚证") return "扶阳解毒颗粒";
    if (result === "肺脾气虚证") return "芪苓益气片";
    return "/";
  }
  private get bianzhengMainSymptomsText() {
    if (!this.bianzhengData) return "/";
    const list = this.bianzhengData.selectedMainSymptoms || [];
    if (!Array.isArray(list) || list.length === 0) return "/";
    return list.join("；");
  }
  private get bianzhengSecondarySymptomsText() {
    if (!this.bianzhengData) return "/";
    const list = this.bianzhengData.selectedSecondarySymptoms || [];
    if (!Array.isArray(list) || list.length === 0) return "/";
    return list.join("；");
  }

  private ensureZhenghouModule() {
    if (!this.data.report) this.$set(this.data, "report", {});
    if (!this.data.report.zhuanbing) this.$set(this.data.report, "zhuanbing", {});
    if (!this.data.report.zhuanbing.modules) this.$set(this.data.report.zhuanbing, "modules", {});
    if (!this.data.report.zhuanbing.modules.zhenghou) this.$set(this.data.report.zhuanbing.modules, "zhenghou", {});
    const m = this.data.report.zhuanbing.modules.zhenghou;
    if (!m.form) this.$set(m, "form", {});
    if (!m.checkedMap) this.$set(m, "checkedMap", {});
    if (!m.optionInputMap) this.$set(m, "optionInputMap", {});
    if (!m.scoreMap) this.$set(m, "scoreMap", {});
    return m;
  }

  private emitChangeData() {
    this.$emit("changeData", JSON.parse(JSON.stringify(this.data)));
  }

  private getZhenghouFormValue(key: string) {
    return (this.zhenghouData && this.zhenghouData.form && this.zhenghouData.form[key]) || "";
  }

  private onFormInput(key: string, e: Event) {
    const target = e.target as HTMLInputElement | null;
    const m = this.ensureZhenghouModule();
    this.$set(m.form, key, target ? target.value : "");
    this.emitChangeData();
  }

  private isZhenghouSelected(key: string, opt: string) {
    const map = (this.zhenghouData && this.zhenghouData.checkedMap) || {};
    return (map[key] || []).includes(opt);
  }

  private toggleZhenghouChoice(key: string, opt: string) {
    const m = this.ensureZhenghouModule();
    const current = (m.checkedMap[key] || []) as string[];
    if (current.includes(opt)) {
      this.$set(m.checkedMap, key, current.filter((v) => v !== opt));
    } else {
      this.$set(m.checkedMap, key, [...current, opt]);
    }
    this.emitChangeData();
  }

  private hasOptionInput(opt: string) { return opt.includes("___"); }
  private getOptionTextPrefix(opt: string) { return this.hasOptionInput(opt) ? opt.split(/_{2,}/)[0] : opt; }
  private getOptionTextSuffix(opt: string) { return this.hasOptionInput(opt) ? opt.split(/_{2,}/).slice(1).join("") : ""; }
  private getOptionInputKey(groupKey: string, opt: string) { return `${groupKey}__${opt}`; }
  private getOptionInputValue(groupKey: string, opt: string) {
    const map = (this.zhenghouData && this.zhenghouData.optionInputMap) || {};
    return map[this.getOptionInputKey(groupKey, opt)] || "";
  }

  private onOptionInput(groupKey: string, opt: string, e: Event) {
    const target = e.target as HTMLInputElement | null;
    const m = this.ensureZhenghouModule();
    this.$set(m.optionInputMap, this.getOptionInputKey(groupKey, opt), target ? target.value : "");
    this.emitChangeData();
  }

  private getScoreKey(sectionTitle: string, rowIndex: number) { return `${sectionTitle}__${rowIndex}`; }
  private getScoreValue(sectionTitle: string, rowIndex: number) {
    const map = (this.zhenghouData && this.zhenghouData.scoreMap) || {};
    return map[this.getScoreKey(sectionTitle, rowIndex)] || "";
  }

  private onScoreInput(sectionTitle: string, rowIndex: number, e: Event) {
    const target = e.target as HTMLInputElement | null;
    const m = this.ensureZhenghouModule();
    this.$set(m.scoreMap, this.getScoreKey(sectionTitle, rowIndex), target ? target.value : "");
    this.emitChangeData();
  }

  private getSizhenConclusion(item: any): string {
    if (!item) return "";
    if (typeof item === "string") return item;
    const parsed = this.formatByFilter(item);
    if (parsed) return parsed;
    if (typeof item.result === "string" && item.result) return item.result;
    return "/";
  }

  private formatByFilter(item: any): string {
    if (!item || !item.report) return "";
    try {
      const type = item.template_data && item.template_data[0] ? item.template_data[0].type : (item.data && item.data[0] ? item.data[0].type : "");
      let str = "";
      if (type === "舌象80" && item.report["舌象信息"]) {
        const keys = ["舌神", "舌色", "舌形", "舌态", "苔质", "苔色"];
        const d: any = item.report["舌象信息"];
        keys.forEach((k) => {
          if (d[k] && d[k].length > 0) {
            const part = ([] as any[]).concat(d[k][0] || [], d[k][1] || []).filter(Boolean).join("、");
            if (part) {
              if (str) str += "；";
              str += `${k}：${part}`;
            }
          }
        });
      } else if (type === "舌底" && item.report["舌底信息"]) {
        const keys = ["长度", "形态", "颜色", "粗细"];
        const d: any = item.report["舌底信息"];
        keys.forEach((k) => {
          if (d[k]) {
            if (str) str += "；";
            str += `${k}：${d[k]}`;
          }
        });
      } else if (type === "面象15" && item.report["面象信息"]) {
        const keys = ["面色", "唇态", "唇色", "鼻光泽", "鼻形态", "鼻颜色", "人中形态", "人中颜色"];
        const d: any = item.report["面象信息"];
        keys.forEach((k) => {
          if (d[k] && d[k].length > 0) {
            if (str) str += "；";
            str += `${k}：${d[k].join("、")}`;
          }
        });
      } else if (type === "脉象6" && item.report["脉象信息输出"] && item.report["脉象信息输出"]["脉名"]) {
        const pos = `${item.report.pulse_hand || ""}${item.report.pulse_pos || ""}`;
        str = `${pos}：${item.report["脉象信息输出"]["脉名"]}`;
      }
      return str || "";
    } catch (e) {
      return "";
    }
  }
}
